/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = CurrentAddress
 *
 * 2 = PreviousAddress
 *
 * 5 = CurrentCompany
 *
 * 6 = PreviousCompany
 */
export enum AddressTypes {
  CurrentAddress = 1,
  PreviousAddress = 2,
  CurrentCompany = 5,
  PreviousCompany = 6,
}
